/**
 * @generated SignedSource<<b6b002da46118fc64f8269e89dcf808d>>
 * @relayHash 63ebc26c4e8f00afe8b0ef90b6f20478
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 517e7bc0b657d6a5cbc2554de9f2e62ee6b8f153890e617c5b562206f56ba7c1

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceAdminAnnouncementBannerStatusType = "PUBLISHED" | "SAVED" | "SCHEDULED" | "%future added value";
export type CompanyHubAnnouncementBannerStatusQuery$variables = {
  bannerId: string;
};
export type CompanyHubAnnouncementBannerStatusQuery$data = {
  readonly adminAnnouncementBannerSetting: {
    readonly id: string;
    readonly status: ConfluenceAdminAnnouncementBannerStatusType;
  } | null | undefined;
};
export type CompanyHubAnnouncementBannerStatusQuery = {
  response: CompanyHubAnnouncementBannerStatusQuery$data;
  variables: CompanyHubAnnouncementBannerStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bannerId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "bannerId"
      }
    ],
    "concreteType": "ConfluenceAdminAnnouncementBannerSetting",
    "kind": "LinkedField",
    "name": "adminAnnouncementBannerSetting",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CompanyHubAnnouncementBannerStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyHubAnnouncementBannerStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63ebc26c4e8f00afe8b0ef90b6f20478",
    "id": "517e7bc0b657d6a5cbc2554de9f2e62ee6b8f153890e617c5b562206f56ba7c1",
    "metadata": {},
    "name": "CompanyHubAnnouncementBannerStatusQuery",
    "operationKind": "query",
    "text": "query CompanyHubAnnouncementBannerStatusQuery($bannerId:String!){adminAnnouncementBannerSetting(id:$bannerId){id,status}}"
  }
};
})();

(node as any).hash = "0729b964654c5bed0f702b89156648b8";

export default node;
